<on-page-title
    [title]="'expense.create-expense' | translate"
    icon="fa-receipt"
></on-page-title>

<on-edit-page [isNew]="true"></on-edit-page>
